import GradientTabButton from "@/lib/components/Button/GradientTabButton";
import { IconTypography, IconUpload } from "@tabler/icons-react";

export type FontDialogTab = "ALL_FONTS" | "ADD_FONT";

export function FontTabs({
  activeTab,
  onTabChange,
}: {
  activeTab: FontDialogTab;
  onTabChange: (tab: FontDialogTab) => void;
}) {
  const tabs = [
    {
      id: "ALL_FONTS" as const,
      label: "All Fonts",
      icon: IconTypography,
    },
    {
      id: "ADD_FONT" as const,
      label: "Add Font",
      icon: IconUpload,
    },
  ];

  return (
    <div className="flex flex-col gap-3 border-b border-grey-200 p-6">
      {tabs.map((tab) => (
        <GradientTabButton
          key={tab.id}
          icon={tab.icon}
          label={tab.label}
          isActive={activeTab === tab.id}
          onClick={() => onTabChange(tab.id)}
        />
      ))}
    </div>
  );
}
